import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import {
    ROUTE_DASHBOARD,
    ROUTE_DOWNLOAD_CHALLENGES,
    ROUTE_CHALLENGES,
    ROUTE_CAMPAIGNS,
    ROUTE_SEGMENTS,
    ROUTE_RESEARCH,
    ROUTE_RESOURCES,
    ROUTE_ADMIN,
    ROUTE_EXPORT,
    ROUTE_ANALYZE_RESEARCH,
    ROUTE_TAGGING,
} from '../constants';
import { isUserLoggedIn } from '../../screens/auth/selectors';
import './styles.scss';
const ACTIVE_CLASS_NAME = 'active';

import {
    DASHBOARD_VIEW,
    CHALLENGE_VIEW,
    CAMPAIGN_LIST_VIEW,
    SEGMENTS_VIEW,
    REPORT_VIEW,
    RESOURCES_VIEW,
    RESEARCH_VIEW,
    ADMIN_VIEW,
    MULTILITTER_VIEW,
} from '../../screens/auth/constants';
import Authorization from '../../screens/auth/Authorization';
//  import CampaignIcon from '../../icons/campaign.svg';

export function AuthenicatedNavigation({ isUserLoggedIn }) {
    return (
        isUserLoggedIn && (
            <aside className="col-md-2 col-lg-1 hidden-xs-down bg-faded sidebar d-none d-md-block">
                <ul className="nav nav-pills flex-column">
                    {/* dashboard screen */}
                    <Authorization
                        accessToCheck={DASHBOARD_VIEW}
                        onApproval={() => {
                            return (
                                <li className="nav-item">
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_DASHBOARD}
                                    >
                                        <i
                                            className="icon-dashboard"
                                            aria-hidden="true"
                                        ></i>
                                        dashboard
                                    </NavLink>
                                </li>
                            );
                        }}
                    />

                    {/* tagging screen */}
                    <Authorization
                        accessToCheck={MULTILITTER_VIEW}
                        onApproval={() => {
                            return (
                                <li className="nav-item">
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_TAGGING}
                                    >
                                        <i
                                            className="fa fa-tags"
                                            aria-hidden="true"
                                        ></i>
                                        Tagging
                                    </NavLink>
                                </li>
                            );
                        }}
                    />

                    {/* challenges screen */}
                    <Authorization
                        accessToCheck={CHALLENGE_VIEW}
                        onApproval={() => {
                            return (
                                <li className="nav-item">
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_CHALLENGES}
                                    >
                                        <i
                                            className="icon-flag"
                                            aria-hidden="true"
                                        ></i>
                                        Challenges
                                    </NavLink>
                                </li>
                            );
                        }}
                    />
                    {/* campaigns screen */}
                    <Authorization
                        accessToCheck={CAMPAIGN_LIST_VIEW}
                        onApproval={() => {
                            return (
                                <li className="nav-item">
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_CAMPAIGNS}
                                    >
                                        <i
                                            className="fa fa-bullhorn"
                                            aria-hidden="true"
                                        ></i>
                                        {/* <div><img src={CampaignIcon} /></div> */}
                                        Campaigns
                                    </NavLink>
                                </li>
                            );
                        }}
                    />

                    {/* challenges downloads screen */}
                    <Authorization
                        accessToCheck={REPORT_VIEW}
                        onApproval={() => {
                            return (
                                <li className="nav-item">
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_DOWNLOAD_CHALLENGES}
                                    >
                                        <i
                                            className="icon-download"
                                            aria-hidden="true"
                                        ></i>
                                        reports
                                    </NavLink>
                                </li>
                            );
                        }}
                    />

                    {/* segments screen */}
                    <Authorization
                        accessToCheck={SEGMENTS_VIEW}
                        onApproval={() => {
                            return (
                                <li className={'nav-item'}>
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_SEGMENTS}
                                    >
                                        <i
                                            className="icon3-listing"
                                            aria-hidden="true"
                                        ></i>
                                        Segments
                                    </NavLink>
                                </li>
                            );
                        }}
                    />
                    {/** Analyze Research Screen */}
                    <li className={'nav-item'}>
                        <NavLink
                            className={'nav-link'}
                            activeClassName={ACTIVE_CLASS_NAME}
                            to={ROUTE_ANALYZE_RESEARCH}
                        >
                            <i className="icon-research" aria-hidden="true"></i>
                            {`Analyze (Beta)`}
                        </NavLink>
                    </li>

                    {/* Use this logic to hide a link on the sidbar for super admins only */}
                    {/* compare first digit of current user role to super admin role = 4 */}
                    {/* {ROLE_SUPER_ADMIN.toString() ===
                        currentRole.toString().split('')[0] && (
                    )} */}

                    {/** Resource Management Screen */}
                    <Authorization
                        accessToCheck={RESEARCH_VIEW}
                        onApproval={() => {
                            return (
                                <li className={'nav-item'}>
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_RESEARCH}
                                    >
                                        <i
                                            className="icon-research"
                                            aria-hidden="true"
                                        ></i>
                                        Research Management
                                    </NavLink>
                                </li>
                            );
                        }}
                    />
                    <Authorization
                        accessToCheck={RESOURCES_VIEW}
                        onApproval={() => {
                            return (
                                <li className={'nav-item'}>
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_RESOURCES}
                                    >
                                        <i
                                            className="icon-resource"
                                            aria-hidden="true"
                                        ></i>
                                        Resources
                                    </NavLink>
                                </li>
                            );
                        }}
                    />

                    {/* Admin screen */}
                    <Authorization
                        accessToCheck={ADMIN_VIEW}
                        onApproval={() => {
                            return (
                                <li className={'nav-item'}>
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_ADMIN}
                                    >
                                        <i
                                            className="icon-latest-admin"
                                            aria-hidden="true"
                                        ></i>
                                        Admin
                                    </NavLink>
                                </li>
                            );
                        }}
                    />

                    {/* Export screen */}
                    <Authorization
                        accessToCheck={ADMIN_VIEW}
                        onApproval={() => {
                            return (
                                <li className={'nav-item'}>
                                    <NavLink
                                        className={'nav-link'}
                                        activeClassName={ACTIVE_CLASS_NAME}
                                        to={ROUTE_EXPORT}
                                    >
                                        <i
                                            className="icon-latest-admin"
                                            aria-hidden="true"
                                        ></i>
                                        Export
                                    </NavLink>
                                </li>
                            );
                        }}
                    />
                </ul>
            </aside>
        )
    );
}

AuthenicatedNavigation.propTypes = {
    // function to be called when payment field's value is changed
    isUserLoggedIn: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        isUserLoggedIn: isUserLoggedIn(state),
    };
};

const ConnectedAuthenicatedNavigation = connect(mapStateToProps)(
    AuthenicatedNavigation,
);

export default ConnectedAuthenicatedNavigation;
